/**
 * Vendor org Library Documents tab lists catalog docs (document_status), not sponsor
 * request lifecycle. Shared doc-card menus must not apply Document Library discovery
 * actions (Request Access / partial exports / Cancel) to those rows (BUG 14491).
 */

export function isOrgVendorLibraryContext(archiveDocumentContext) {
  return archiveDocumentContext === "vendorOrg";
}

/**
 * Catalog "Published" VQQ on the vendor org tab is completed Library content — same
 * view/download surface as Complete/Released, not discovery "requestable".
 */
export function isOrgVendorLibraryPublishedVqq({
  archiveDocumentContext,
  documentType,
  isDocLibrary,
  status,
  questionnaireId,
}) {
  const typeKey = String(documentType || "").toUpperCase();
  const statusLc = String(status || "").trim().toLowerCase();
  return (
    isOrgVendorLibraryContext(archiveDocumentContext) &&
    typeKey === "RFI" &&
    Boolean(isDocLibrary) &&
    statusLc === "published" &&
    questionnaireId !== null &&
    questionnaireId !== undefined &&
    questionnaireId !== ""
  );
}
